class BannerMessageService {
  constructor($http, config) {
    this.$http = $http;
    this.config = config;
  }

  getMessage() {
    let url = `${this.config.apiRoot}/systemMessages`;
    return this.$http.get(url);
  }

  setMessage(message,expirationTime) {
    let url = `${this.config.apiRoot}/systemMessages`;
    return this.$http.post(url,{message,expirationTime});
  }
}

BannerMessageService.$inject = ['$http', 'config'];

export default BannerMessageService;



// WEBPACK FOOTER //
// ./app/common/bannerMessage/bannerMessage.service.js